import { PayloadAction } from '@reduxjs/toolkit';
import { random } from 'lodash';
import { all, call, cancel, delay, fork, put, select, takeEvery } from 'typed-redux-saga';

import { ChannelHolder } from '../../helpers/channelHolder';
import { selectIsDiagnosticsEnabled } from '../flags/selectors';
import { goloomSdk, MeanOpinionScore } from '../goloom-sdk';
import { addMessage, clearMessages, diagnosticsMessageMock } from './slice';
import { DiagnosticsMessage } from './types';

function* addMessageSaga(action: PayloadAction<DiagnosticsMessage>) {
    yield* put(addMessage(action.payload));
}

function* initMockDiagnosticsSaga() {
    const channelHolder = new ChannelHolder();
    const diagnosticsEnabled = yield* select(selectIsDiagnosticsEnabled);
    if (!diagnosticsEnabled) {
        return;
    }

    yield* put(clearMessages());

    const sendDiagnosticMessageTask = yield* fork(sendDiagnosticMessageSaga);
    yield* channelHolder.take(goloomSdk.onDestroy);
    yield* cancel(sendDiagnosticMessageTask);
    channelHolder.close();
}

function* sendDiagnosticMessageSaga() {
    while (true) {
        yield* put(
            diagnosticsMessageMock({
                timestamp: Date.now(),
                mos: Object.values(MeanOpinionScore)[random(0, 2)],
                bitrate: random(200, 1000),
                packetLoss: random(0, 10),
                cpuLoad: random(0, 100),
                rtt: random(1, 10),
            })
        );
        yield* call(delay, 1000);
    }
}

export function* diagnosticsSaga() {
    const channelHolder = new ChannelHolder();

    try {
        yield* all([
            channelHolder.takeEvery(goloomSdk.onInit, initMockDiagnosticsSaga),
            takeEvery(diagnosticsMessageMock, addMessageSaga),
        ]);
    } finally {
        channelHolder.close();
    }
}
